import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { DefiLlamaProtocolsResponse } from "@bridgesplit/abf-sdk";

const DEFI_LLAMA_TAG = "DefiLlamaList";
export const defiLlamaExternalApi = createApi({
    reducerPath: "defiLlamaExternalApi",
    tagTypes: [DEFI_LLAMA_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "https://api.llama.fi/" }),
    endpoints: (builder) => ({
        defiLlamaProtocolTvl: builder.query<DefiLlamaProtocolsResponse, void>({
            providesTags: [DEFI_LLAMA_TAG],
            query: () => ({
                url: "/protocols",
                method: "GET"
            })
        })
    })
});
export function useDefiLlamaExternalApi() {
    const dispatch = useDispatch();
    return { resetDefiLlamaExternalApi: () => dispatch(defiLlamaExternalApi.util.invalidateTags([DEFI_LLAMA_TAG])) };
}
